// extracted by mini-css-extract-plugin
export default {"lined_text":"TextualSeparator_lined_text__oBEjR","line_before_text":"TextualSeparator_line_before_text__ukWEN","line_after_text":"TextualSeparator_line_after_text__xB-sJ"};